
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 20 20","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M15.833 3.333H15V2.5a.836.836 0 00-.833-.833.836.836 0 00-.834.833v.833H6.667V2.5a.836.836 0 00-.834-.833A.836.836 0 005 2.5v.833h-.833A1.66 1.66 0 002.508 5L2.5 16.667c0 .916.742 1.666 1.667 1.666h11.666c.917 0 1.667-.75 1.667-1.666V5c0-.917-.75-1.667-1.667-1.667zm0 12.5a.836.836 0 01-.833.834H5a.836.836 0 01-.833-.834V7.5h11.666v8.333zm-8.333-5V9.167H5.833v1.666H7.5zm1.667-1.666h1.666v1.666H9.167V9.167zm5 1.666V9.167H12.5v1.666h1.667z","fill":"#9AA0B5"}})])
          )
        }
      }
    